export interface WebSocketConnection {
    clientId: string;
}

export interface WebSocketMessage {
    type: string;
    payload: any;
}

export interface WebSocketTaskResult extends WebSocketMessage {
    type: 'TaskResult';
    taskId: string;
    success: boolean;
    done: boolean;
}

export interface WebSocketRefreshRequest extends WebSocketMessage {
    type: 'RefreshRequest';
    clientId: string;
    payload: {
        [refreshType: string]: any;
    };
}

const isWebsocketMessage = (message: any): message is WebSocketMessage =>
    message && typeof message.type === 'string';

export const isWebSocketTaskResult = (message: any): message is WebSocketTaskResult =>
    isWebsocketMessage(message) && message.type === 'TaskResult';

export const isWebSocketRefreshRequest = (message: any): message is WebSocketRefreshRequest =>
    isWebsocketMessage(message) && message.type === 'RefreshRequest';
